import q from "./index49.js";
import C from "./index85.js";
import D from "./index71.js";
import n from "./index60.js";
import L from "./index55.js";
import U from "./index86.js";
import v from "./index73.js";
import x from "./index63.js";
import { progressEventReducer as y } from "./index87.js";
import O from "./index88.js";
import { toByteStringHeaderObject as k } from "./index75.js";
const M = typeof XMLHttpRequest < "u", G = M && function(s) {
  return new Promise(function(A, l) {
    const t = O(s);
    let T = t.data;
    const R = x.from(t.headers).normalize();
    let { responseType: d, onUploadProgress: h, onDownloadProgress: g } = t, u, w, b, p, m;
    function a() {
      p && p(), m && m(), t.cancelToken && t.cancelToken.unsubscribe(u), t.signal && t.signal.removeEventListener("abort", u);
    }
    let e = new XMLHttpRequest();
    e.open(t.method.toUpperCase(), t.url, !0), e.timeout = t.timeout;
    function H() {
      if (!e)
        return;
      const o = x.from(
        "getAllResponseHeaders" in e && e.getAllResponseHeaders()
      ), i = {
        data: !d || d === "text" || d === "json" ? e.responseText : e.response,
        status: e.status,
        statusText: e.statusText,
        headers: o,
        config: s,
        request: e
      };
      C(
        function(E) {
          A(E), a();
        },
        function(E) {
          l(E), a();
        },
        i
      ), e = null;
    }
    "onloadend" in e ? e.onloadend = H : e.onreadystatechange = function() {
      !e || e.readyState !== 4 || e.status === 0 && !(e.responseURL && e.responseURL.startsWith("file:")) || setTimeout(H);
    }, e.onabort = function() {
      e && (l(new n("Request aborted", n.ECONNABORTED, s, e)), a(), e = null);
    }, e.onerror = function(r) {
      const i = r && r.message ? r.message : "Network Error", f = new n(i, n.ERR_NETWORK, s, e);
      f.event = r || null, l(f), a(), e = null;
    }, e.ontimeout = function() {
      let r = t.timeout ? "timeout of " + t.timeout + "ms exceeded" : "timeout exceeded";
      const i = t.transitional || D;
      t.timeoutErrorMessage && (r = t.timeoutErrorMessage), l(
        new n(
          r,
          i.clarifyTimeoutError ? n.ETIMEDOUT : n.ECONNABORTED,
          s,
          e
        )
      ), a(), e = null;
    }, T === void 0 && R.setContentType(null), "setRequestHeader" in e && q.forEach(k(R), function(r, i) {
      e.setRequestHeader(i, r);
    }), q.isUndefined(t.withCredentials) || (e.withCredentials = !!t.withCredentials), d && d !== "json" && (e.responseType = t.responseType), g && ([b, m] = y(g, !0), e.addEventListener("progress", b)), h && e.upload && ([w, p] = y(h), e.upload.addEventListener("progress", w), e.upload.addEventListener("loadend", p)), (t.cancelToken || t.signal) && (u = (o) => {
      e && (l(!o || o.type ? new L(null, s, e) : o), e.abort(), a(), e = null);
    }, t.cancelToken && t.cancelToken.subscribe(u), t.signal && (t.signal.aborted ? u() : t.signal.addEventListener("abort", u)));
    const c = U(t.url);
    if (c && !v.protocols.includes(c)) {
      l(
        new n(
          "Unsupported protocol " + c + ":",
          n.ERR_BAD_REQUEST,
          s
        )
      ), a();
      return;
    }
    e.send(T || null);
  });
};
export {
  G as default
};
